import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import AdvanceNotice from 'components/Calendar/AdvanceNotice';
import { fetchReminderSettings } from 'api/calendarSetting';
import { ReminderSettings } from 'types/calendarSetting';
import { useSwitchedProvider } from 'pages/ReviewProviderProfilePage/SwitchedProviderContext';
import s from './s.module.less';

export type AdvanceNoticeStepRef = { submit: () => Promise<boolean> };

const AdvanceNoticeStep = forwardRef<AdvanceNoticeStepRef>((_props, ref) => {
    const { scheduleToken } = useSwitchedProvider();
    const advanceNoticeRef = useRef<any>(null);
    // current saved reminder setting for the created provider, used to restore on Back
    const [reminderValue, setReminderValue] = useState<ReminderSettings | null>(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const res = await fetchReminderSettings(scheduleToken);
            if (!cancelled && res?.data?.code === 200) {
                setReminderValue(res.data.data || null);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [scheduleToken]);

    // Save the advance-notice setting to the created provider (inner component saves via token).
    useImperativeHandle(ref, () => ({
        submit: async () => {
            await advanceNoticeRef.current?.onUpdate();
            return true;
        },
    }));

    return (
        <div className={s.wrap}>
            <h1 className={s.heading}>When should patients book before their visit?</h1>
            <p className={s.description}>
                Set how far in advance patients must book an appointment. This ensures you have enough time to prepare.
            </p>
            <div className={s.form}>
                <div className={s.label}>Advance notice</div>
                <AdvanceNotice value={reminderValue} ref={advanceNoticeRef} scheduleToken={scheduleToken} />
            </div>
        </div>
    );
});

export default AdvanceNoticeStep;
